import Mutations from '../../odata/mutations';

export default { ...new Mutations('keywordAlternative'), ...new Mutations('keywordAlternatives') };
